







import { Vue, Prop, Component } from 'vue-property-decorator'
@Component({
  name: 'AvgScore'
})
export default class extends Vue {
  @Prop({ required: true }) private score!: string;
  @Prop({ default: '#00B66C' }) private color!: string;
  @Prop({ default: '占比' }) private label!: string;
}
